import React, { useContext, useRef } from "react";
import { Link } from "react-router-dom";
import { handleCustomLinkIn, handleCustomLinkOut } from "../animations/desktop";
import LocaleContext from "../context/LocaleContext";

function CustomLink({ path, text, border, linkType, url }) {
  const customLink = useRef(null);
  const customLinkMask = useRef(null);
  const {pageX,pageY} = useContext(LocaleContext);

  return (
    <>
      {linkType === "external" ? (
        <a
          className="ahdc-link"
          href={url}
          ref={customLink}
          onMouseEnter={() => handleCustomLinkIn(customLink, customLinkMask,pageX,pageY)}
          onMouseOut={() => handleCustomLinkOut(customLink, customLinkMask,pageX,pageY)}
        >
          <span className="ahdc-link__mask" ref={customLinkMask}></span>
          {text}
        </a>
      ) 
      : (
        <Link
          className={
            border === true
              ? `ahdc-link ahdc-link--border-transparent`
              : `ahdc-link`
          }
          to={path}
          ref={customLink}
          onMouseEnter={() => handleCustomLinkIn(customLink, customLinkMask,pageX,pageY)}
          onMouseOut={() => handleCustomLinkOut(customLink, customLinkMask,pageX,pageY)}
        >
          <span className="ahdc-link__mask" ref={customLinkMask}></span>
          {text}
        </Link>
      )}
    </>
  );
}

export default CustomLink;
